import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api-service/api.service';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css'],
})
export class UserDetailsComponent {
  constructor(private apiService: ApiService, private route: ActivatedRoute) {}

  isLoading = true;
  userId: string = '';
  userDetailsData: any = [];
  licensePlatesData: any = [];
  ticketCount: number = 0;
  activeSubscriptionsData: any = [];
  subscriptions: any = [];
  dtOptions: DataTables.Settings = {};

  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get('userId') || '';

    this.apiService.getUserDetails(this.userId).subscribe(
      (response: any) => {
        this.userDetailsData = response;

        this.userDetailsData.firstName = this.getUserFirstNameString();
        this.isLoading = false;
      },
      (error: any) => {
        console.error('API Error:', error);
        this.isLoading = false;
      }
    );

    this.apiService.getUserLicensePlates(this.userId).subscribe(
      (response: any) => {
        this.licensePlatesData = response.results;
      },
      (error: any) => {
        console.error('API Error:', error);
      }
    );

    this.apiService
      .getSubscriptionsForUser(this.userId)
      .subscribe((response: any) => {
        console.log(response);
        this.activeSubscriptionsData = response.results.filter(
          (activeSubscriptionData: any) =>
            activeSubscriptionData.subscriptions.length > 0
        );
      });

    this.apiService
      .getTicketCountForUser(this.userId)
      .subscribe((response: any) => {
        this.ticketCount = response.count;
      });
  }

  getUserFirstNameString() {
    let firstNameString = '';

    if (this.userDetailsData.loginType === 'anonymous') {
      firstNameString = 'Guest #' + this.userDetailsData.id.split('-')[0];
    } else {
      firstNameString = this.userDetailsData.firstName || '-';
    }

    return firstNameString;
  }
}
